var $2f9e52c02bf38498$exports = {};
$2f9e52c02bf38498$exports = {
    "endTime": `Vrijeme zavr\u{161}etka`,
    "startTime": `Vrijeme po\u{10D}etka`,
    "time": `Vrijeme`
};


export {$2f9e52c02bf38498$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
